import { Navigate } from "react-router-dom";

export type ProtectedRouteProps = {
  children: React.ReactNode;
  requiredScopes: string[];
  userScopes?: string[];
  redirectTo?: string;
};

const ProtectedRoute = ({
  children,
  requiredScopes,
  userScopes = [],
  redirectTo = "/events",
}: ProtectedRouteProps) => {
  const hasPermission = requiredScopes.some((scope) =>
    userScopes.includes(scope)
  );
  return hasPermission ? <>{children}</> : <Navigate to={redirectTo} replace />;
};

export default ProtectedRoute;
